import { OrderDetailsPage } from "@pages/ordersPage/orderDetailsPage";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { compose } from "redux";

import {
    ApproveOrderArticleProps,
    GetOrdersProps,
    RejectOrderArticleProps,
    withApproveOrderArticle,
    withRejectOrderArticle,
    withGetOrders

} from "../../graphql2/types";

export interface OrderDetailsPageContainerProps extends RouteComponentProps<{ id: string; }> {

}

const withOrder = withGetOrders({
    name: "order",
    options(props: OrderDetailsPageContainerProps) {
        return {
            variables: {
                filter: {
                    ids: [props.match.params.id]
                }
            }
        };
    }
});

export const OrderDetailsPageContainer = compose<React.ComponentClass<OrderDetailsPageContainerProps>>(
    withRouter,
    withOrder,
    withApproveOrderArticle({
        name: "approveOrderArticle",
        options: {
            refetchQueries: ["order"],
            awaitRefetchQueries: true
        }
    }),
    withRejectOrderArticle(
        {
            name: "rejectOrderArticle",
            options: {
                refetchQueries: ["order"],
                awaitRefetchQueries: true
            }
        }
    )
)(OrderDetailsPage);

export type OrderDetailsPageProps =
    RouteComponentProps<{ id: string; }> &
    GetOrdersProps<{}, "order"> &
    ApproveOrderArticleProps<{}, "approveOrderArticle"> &
    RejectOrderArticleProps<{}, "rejectOrderArticle"> &
    OrderDetailsPageContainerProps;
